export default "__VITE_ASSET__BpOyWpgH__"